import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import { useSelector } from 'react-redux'
import { selectUser } from '../app/features/user/userSlice'
import { getDataById, updateDataById } from '../apis/generalApis'
import { Button } from '@mui/material'
import Swal from 'sweetalert2'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const ClosingMessageModal = ({
  handleClosingMessageModal,
  closingMessageModal = false,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  React.useEffect(() => {
    getClosingMessages()
  }, [])

  const [closingMessage, setClosingMessage] = React.useState({
    client_message: '',
    message_ongoing_task: '',
    closing_message_id: null,
  })

  const getClosingMessages = async () => {
    let body = {
      user_id: user?.id,
    }
    let result = await getDataById('show-closing-messages', body)
    if (result?.success === true && result?.data != null) {
      setClosingMessage({
        ...closingMessage,
        client_message: result?.data?.client_message,
        message_ongoing_task: result?.data?.message_ongoing_task,
        closing_message_id: result?.data?.id,
      })
    }
  }

  const handleClosingMessageChange = (e) => {
    setClosingMessage({ ...closingMessage, [e.target.name]: e.target.value })
  }

  const updateClodingMessage = async () => {
    if (
      closingMessage.client_message !== '' &&
      closingMessage.message_ongoing_task !== ''
    ) {
      const body = {
        user_id: user?.id,
        message: closingMessage.client_message,
        message_ongoing_task: closingMessage.message_ongoing_task,
        closing_message_id: closingMessage.closing_message_id,
      }
      let result = await updateDataById('update-closing-message', body)
      if (result?.success === true) {
        Swal.fire({
          icon: 'success',
          title: 'Closing message updated successfully!',
          timer: 3000,
          confirmButtonColor: '#2597F6'
        })
        handleClosingMessageModal(false)
      }
    }
  }

  return (
    <>
      <Modal
        open={closingMessageModal}
        onClose={() => handleClosingMessageModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="closing-message">
          <div>
            <h3 className="fs-24 fw-bold">Closing Message</h3>
            <p className="fs-16 m-0 mt-3 font-weight-bold">
              This is what your client see about you
            </p>
            <p className="fs-16 m-0 font-weight-bold">
              Edit your default closing statement to clients
            </p>
            <div className="bordered-text px-2 pt-2 text-left mt-2">
              <textarea
                className="customer-support-message"
                name="client_message"
                cols="30"
                rows="5"
                value={closingMessage.client_message}
                onChange={handleClosingMessageChange}
              ></textarea>
            </div>
            <p className="fs-16 m-0 mt-3 font-weight-bold">
              Edit your default closing statement to clients for ongoing tasks
            </p>
            <div className="bordered-text px-2 pt-2 text-left mt-2">
              <textarea
                className="customer-support-message"
                name="message_ongoing_task"
                cols="30"
                rows="5"
                value={closingMessage.message_ongoing_task}
                onChange={handleClosingMessageChange}
              ></textarea>
            </div>
            <Button
              id="btn-primary-no-shadow"
              className="pointer mt-4"
              fullWidth
              onClick={updateClodingMessage}
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default ClosingMessageModal
